import axios from 'axios'

const instance = () => {
    const headersConfig = {
        'content-type': 'multipart/form-data',
        'Accept':'application/json'
    }

    if (localStorage.getItem('token'))
        headersConfig['Authorization'] = `Bearer ${localStorage.getItem('token')}`

    return axios.create({
        baseURL: process.env.REACT_APP_DEV,
        headers: headersConfig
    })
}

const navServices = {
    getMainNav: () => {
        return instance().get('/api/front/navigation-bar/')
    },
}

const userServices = {
    loginUser: (formData) => {
        return instance().post('/api/auth/users/login', formData )
    },
    loginFacebook: () => {
        return axios.get('https://oneroof.site/api/auth/social-login/facebook/')
       // return instance().get('/api/auth/social-login/facebook/')
    },
    loginFacebookCallback: (data) => {
        return instance().get(`https://oneroof.site/api/auth/social-login/facebook/callback/${data}`)
    },
    
    loginGoogle:()=>{
        return axios.get('https://oneroof.site/api/auth/social-login/google/')
       // return instance().get('/api/auth/social-login/google/')
    }
}

const productServices = {
    getProduct: (formData) => {
        return instance().post('/api/front/product-listing/', formData)
    },
    getProductDetail: (category, id) => {
        return instance().get('/api/front/product/' + category + '/' + id)
    },
    addToCart: (formData) => {
        return instance().post('/api/buyer/cart', formData)
    },
    getAllCart:()=>{
        return instance().get('/api/buyer/cart')
    },
    removeProduct:(id)=>{
        return instance().post(`api/buyer/cart/remove-item/${id}`)
    }
    
}
const couponServices = {
    applyCoupon:(data)=>{
        return instance().post('api/buyer/cart/coupon',data)
    }
}

export default {
    navServices,
    userServices,
    productServices
};
